export default __webpack_public_path__ + "static/media/Transportation_05.ad3499bb.png";